import React, { useState, useEffect } from "react";
import "./Flights.css";
import plane from "../../assets/images/home/hero-plane.svg";
import { Container, Tabs, Tab } from "react-bootstrap";
import hotel from "../../assets/images/packages/svg/flight.svg";
import Cookies from "js-cookie";
import { useTranslation } from "../../contexts/TranslationContext";
import { useNavigate } from "react-router-dom";
import { FlightSearchBar } from "../../Features/FlightList";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const Flights = ({ url }) => {
  const Lang = Cookies.get("preferred_language") || "en";
  const navigate = useNavigate();
  const { t } = useTranslation();

  // State for hotel search
  const [flightSearchState, setFlightSearchState] = useState({
  departure: "",      
  destination: "",    
  leaving: "",    
  adults: 2,       
  children: 0,   
  infants:0,    
  search_type: "city",
  search_query: "",   
  destinationId: ""   
  });
  
const [travelers, setTravelers] = useState({
  adults: 2,
  children: 0,
  childrenAges: [],
  infants: 0
});




const handleFlightDiscover = () => {
  localStorage.setItem(
    "lastFlightSearch",
    JSON.stringify({
      flightSearchState,
      travelers,
      flightsData: null, 
    })
  );

  navigate("/flights", {
    state: { flightSearchState, travelers },
  });
};

  return (
    <div className="hero hotel-page-container">
      <img
        src={require("../../assets/images/home/hero.png")}
        alt=""
        className="hero-background hotel-page-container-bg"
      />
      <Container>
        <div className="hero-content">
          <div className="hero-desc"></div>
          <div className="hero-title">{t("BookYourFlight")}</div>
          <img
            className="hero-plane"
            data-aos="fade-down"
            data-aos-duration="1200"
            src={plane}
            alt=""
          />
          <div
            className="hero-form"
            data-aos="fade"
            data-aos-duration="1200"
            data-aos-delay="900"
          >
            <div className="hero-form-container">
              <Tabs defaultActiveKey="hotels" id="hero-tabs" className="mb-3">
                <Tab
                  eventKey="hotels"
                  title={
                    <span className="tab-title">
                      <img src={hotel} alt="Hotel" className="tab-icon" />
                      <div>{t("Flights")}</div>
                    </span>
                  }
                >
                  {/* Hotel Search Bar */}
                  <div className="hotel-search-container">
                    <FlightSearchBar
                      value={flightSearchState}
                      onChange={setFlightSearchState}
                      onDiscover={handleFlightDiscover}
                      travelers={travelers}
                      onTravelersChange={setTravelers} 
                    />
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </Container>
      <ToastContainer
        position="bottom-right"
        hideProgressBar="true"
        type="error"
      />
    </div>
  );
};

export default Flights;